namespace Umbrella.ChatConversationHandling {
    @Pipe('Umbrella', 'chatProviderName')
    class ChatProviderNameFilter {
        public transform(providerType: ChatProviderType): string {
            return ChatProviderType[providerType];
        }
    }
}
